import { render, staticRenderFns } from "./FiltroSidebar.vue?vue&type=template&id=56f7470d&scoped=true&"
import script from "./FiltroSidebar.vue?vue&type=script&lang=js&"
export * from "./FiltroSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FiltroSidebar.vue?vue&type=style&index=0&id=56f7470d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7470d",
  null
  
)

export default component.exports